import classNames from 'classnames'
import { ReactNode } from 'react'
import { LayoutCard, LayoutCardProps } from '../layout-card'

interface Props extends LayoutCardProps {
  tabList: ReactNode
  /** Lets the tab content fill the card instead of sizing to itself, so it can hold its own scroll areas */
  fullHeightContent?: boolean
}

export const LayoutTablistCard = ({ tabList, children, fullHeightContent, ...props }: Props) => {
  return (
    <LayoutCard fullHeight noPadding {...props}>
      {tabList}
      <div className={classNames('p-8 pt-6', fullHeightContent && 'flex flex-col flex-1 min-h-0')}>{children}</div>
    </LayoutCard>
  )
}
